/**
 * Набор общих утилит.
 * Только самые общие.
 */
import _ from 'lodash'
import Enum from 'glonass/core/Enum'
import { baseUrl } from 'glonass/core/global'

/**
 * Используется в компонентах делающих запросы самостоятельно (не через системный localAxios)
 * @param url
 * @return {string}
 */
export function fullUrl (url) {
  return baseUrl + url
}

export function fileName (path) {
  return path.substr(path.lastIndexOf('/') + 1)
}

/**
 * Переводит любой iterable к общесистемному Enum.
 *
 * @param iterable итерируемая сущность
 * @param {string} labelField имя поля со текстовым представлением
 * @param {string|null} valueField имя поля значения, если передан null в качестве ключа будет взят ключ из итератора
 * @param {boolean} toUpper приводить ли ключи в upper shake case
 * @returns {Enum}
 */
export function iterableToEnum (iterable, labelField, valueField = null, toUpper = false) {
  // console.log(typeof iterable[Symbol.iterator])
  // if (iterable === null || typeof iterable[Symbol.iterator] !== 'function') {
  //   throw new Error('Wrong iterable')
  // }

  let it = iterable

  if (toUpper) {
    it = _.mapKeys(it, (value, key) => _.snakeCase(key).toUpperCase())
  }

  const items = _.mapValues(it, (item, key) => {
    const label = item[labelField]
    const value = valueField ? item[valueField] : key

    return {label, value}
  })

  let keys = []
  let labels = {}
  _.each(items, (item, key) => {
    keys.push(key)
    labels[item.value] = item.label
  })

  const Tmp = class extends Enum {
    static get keys () {
      return keys
    }

    static get name () {
      return 'glonass/core/utils/Tmp'
    }

    static label (value) {
      return labels[value]
    }
  }

  // делаем static поля
  _.each(items, (item, key) => {
    Tmp[key] = item.value
  })

  return Tmp
}

/**
 * Возвращает validator для props Vue-компонентов допускающих null или заданный тип.
 * @param {function|function[]} T типа значения поля {String|Number|Boolean|Function|Object|Array|Symbol} (может быть массивом)
 * @return {function(*): boolean}
 */
export function nullableProp (T) {
  /**
   * Примитивные типы не проверяются через instance of.
   * @param value
   * @param t тип
   */
  function verifyInstance (value, t) {
    switch (t) {
      case String:
        return _.isString(value)
      case Number:
        return _.isNumber(value)
      case Boolean:
        return _.isBoolean(value)
      case Function:
        return _.isFunction(value)
      case Object:
        return _.isObject(value)
      case Array:
        return _.isArray(value)
      case Symbol:
        return _.isSymbol(value)
    }

    throw Error('wrong typeObject for validation nullableProp')
  }

  return (value) => {
    if (value === null) {
      return true
    }

    let result

    if (Array.isArray(T)) {
      result = T.some((t) => verifyInstance(value, t))
    } else {
      result = verifyInstance(value, T)
    }

    if (!result) {
      console.warn('nullableProp', value, T)
    }

    return result
  }
}

/**
 * Облегчает описание vuex-mutations основанных на http запросах.
 * @param {string} mutationType тип мутации
 * @param {string|Function} payloadProp имя поля или функция преобразующая state.
 * @return {Object}
 */
export function httpMutationHelper (mutationType, payloadProp) {
  return {
    [mutationType + '_request'] (state) {
      // сбрасываем ошибки и загрузку
      state.loading[mutationType] = true
      state.success[mutationType] = false
      state.errors[mutationType] = []
    },

    [mutationType + '_failed'] (state, error) {
      state.loading[mutationType] = false
      state.errors[mutationType].push(error)
    },

    [mutationType + '_success'] (state, payload) {
      state.loading[mutationType] = false
      state.success[mutationType] = true

      // сохраняем результат
      if (_.isFunction(payloadProp)) {
        payloadProp(state, payload)
      } else {
        state[payloadProp] = payload
      }
    }
  }
}



// WEBPACK FOOTER //
// ./dev-packages/Core/assets/utils.js